const S3_CLOUDINARY_MAPPINGS = {
  'https://blaze-article-uploads.s3.us-west-1.amazonaws.com/':
    'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_{dimension}/article_uploads/',
  'https://almanac-article-uploads-for-dev.s3.us-west-1.amazonaws.com/':
    'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_{dimension}/almanac_article_uploads_for_dev/',
  'https://blaze-media-uploads-for-dev.s3.us-west-1.amazonaws.com/':
    'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_{dimension}/uploads/',
}

type Dimensions = {
  width?: number
  height?: number
}

export const getTemplatePreviewCloudinaryUrl = (url: string, dimensions: Dimensions = {}) => {
  let dimensionParam = 'w_200'

  if (dimensions.width) {
    dimensionParam = `w_${dimensions.width * 2}`
  } else if (dimensions.height) {
    dimensionParam = `h_${dimensions.height * 2}`
  }

  for (const [key, value] of Object.entries(S3_CLOUDINARY_MAPPINGS)) {
    if (url.startsWith(key)) {
      // Replace the placeholder {dimension} with the appropriate dimension parameter
      const cloudinaryUrl = value.replace('w_{dimension}', dimensionParam)
      return url.replace(key, cloudinaryUrl)
    }
  }

  return url
}
